// App.js
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import "./App.css";

// Regular site components
import Header from './components/header/header';
import Home from "./components/home/Home";
import About from "./components/about/About";
import Skills from "./components/skills/Skills";
import Services from "./components/services/Services";
import Qualification from "./components/qualification/Qualification";
import Portfolio from "./components/portfolio/Portfolio";
import Blog from "./components/blog/Blog";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import Scrollup from "./components/scrollup/Scrollup";
import ChatWidget from "./components/chat/ChatWidget";
import AnimatedCursor from "./components/AnimatedCursor";

// Admin components
import Login from "./components/admin/login/Login";
import Dashboard from "./components/admin/dashboard/Dashboard";
import ProtectedRoute from "./components/admin/ProtectedRoute";

// Blog details page
import BlogDetails from "./components/blog/BlogDetails";

const App = () => {
  const [setIsLoggedIn] = useState(false);

  return (
    <Router>
      <Routes>
        {/* Admin login page */}
        <Route
          path="/admin"
          element={
            <Login onLogin={() => setIsLoggedIn(true)} />
          }
        />

        {/* Admin dashboard - protected */}
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* Public site routes */}
        <Route
          path="/"
          element={
            <>
              <Header />
              <main className="main">
                <Home />
                <About />
                <Skills />
                <Services />
                <Qualification />
                <Portfolio />
                <Blog />
                <Contact />
              </main>
              <Footer />
              <Scrollup />
              <ChatWidget />
              <AnimatedCursor />
            </>
          }
        />

        {/* Blog details route */}
        <Route
          path="/blog/:id"
          element={
            <>
              <Header />
              <main className="main">
                <BlogDetails />
              </main>
              <Footer />
              <Scrollup />
              <ChatWidget />
              <AnimatedCursor />
            </>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
